/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["svg[_ngcontent-%COMP%]{height:15px;width:9px;line-height:1em;display:flex;align-items:center}svg[_ngcontent-%COMP%]   path.path-primary[_ngcontent-%COMP%]{fill:#fa4616}svg[_ngcontent-%COMP%]   path.path-default[_ngcontent-%COMP%]{fill:#9ca4a6}"];
export { styles as styles };
